/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is FD maturity calculated?`)
};

const es_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el vencimiento del FD?`)
};

const de_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird der FD-Fälligkeitswert berechnet?`)
};

const nl_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt FD bij afloop berekend?`)
};

const fr_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la maturité du FD est-elle calculée ?`)
};

const it_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene calcolata la scadenza dell'FD?`)
};

const pt_br2_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculado o vencimento de FD?`)
};

const pt_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculada a maturidade do FD?`)
};

const ja_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FDの満期額はどのように計算されますか？`)
};

const zh_sip_fd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期存款到期金额如何计算？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_faq1_q", locale)
	if (locale === "en") return en_sip_fd_faq1_q(inputs)
	if (locale === "es") return es_sip_fd_faq1_q(inputs)
	if (locale === "de") return de_sip_fd_faq1_q(inputs)
	if (locale === "nl") return nl_sip_fd_faq1_q(inputs)
	if (locale === "fr") return fr_sip_fd_faq1_q(inputs)
	if (locale === "it") return it_sip_fd_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_faq1_q(inputs)
	if (locale === "pt") return pt_sip_fd_faq1_q(inputs)
	if (locale === "ja") return ja_sip_fd_faq1_q(inputs)
	return zh_sip_fd_faq1_q(inputs)
};